document.addEventListener('DOMContentLoaded', function () {
  // Toggle advanced filters
  const toggleBtn = document.querySelector('.js-animals-toggle');
  const filtersForm = document.querySelector('.js-animals-filters');

  if (toggleBtn && filtersForm) {
    toggleBtn.addEventListener('click', function () {
      const isOpen = filtersForm.classList.toggle('is-open');
      toggleBtn.classList.toggle('is-active', isOpen);
      toggleBtn.setAttribute('aria-expanded', isOpen);
    });

    filtersForm.addEventListener('submit', function () {
      Array.from(filtersForm.elements).forEach(function (el) {
        if ((el.tagName === 'INPUT' || el.tagName === 'SELECT') && el.value === '') {
          el.disabled = true;
        }
      });
    });
  }

  // Sort dropdown
  const sortBtn = document.querySelector('.js-animals-sort-btn');
  const sortDropdown = document.querySelector('.js-animals-sort-dropdown');

  if (sortBtn && sortDropdown) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sortDropdown.classList.toggle('is-open');
    });

    document.addEventListener('click', function () {
      sortDropdown.classList.remove('is-open');
    });
  }
});
